import CookieSettingsButton from "@/components/consent/CookieSettingsButton";

type FooterLink = { label: string; href: string };

const productLinks: FooterLink[] = [
  { label: "TR-205 Defense", href: "/product/tr-205-defense/" },
  { label: "Records Request", href: "/product/records-request/" },
  { label: "Certified Mail Filing", href: "/product/certified-mail-filing/" },
  { label: "Premium Defense", href: "/product/premium-defense/" },
];

const accountLinks: FooterLink[] = [
  { label: "My Cases", href: "/dashboard" },
  { label: "Recover Purchase", href: "/recover" },
  { label: "Resume Defense", href: "/defense-hub" },
  { label: "Dashboard", href: "/dashboard" },
];

const supportLinks: FooterLink[] = [
  { label: "Help Center", href: "/help/" },
  { label: "Contact Support", href: "/contact/" },
  { label: "FAQ", href: "/faq/" },
];

const toolsLinks: FooterLink[] = [
  { label: "Speeding Ticket Calculator", href: "/speeding-ticket-cost-calculator/" },
  { label: "California Ticket Guides", href: "/guides/" },
  { label: "Traffic Ticket Resources", href: "/blog/" },
];

const seoLinks: FooterLink[] = [
  { label: "Speeding Ticket Calculator", href: "/speeding-ticket-cost-calculator/" },
  { label: "California Ticket Guides", href: "/guides/" },
  { label: "Los Angeles Traffic Ticket Help", href: "/california/los-angeles-ticket/" },
  { label: "San Francisco Traffic Defense", href: "/california/san-francisco-traffic-defense/" },
  { label: "Speeding Ticket California", href: "/violation/speeding-ticket-california/" },
  { label: "Red Light Camera Ticket", href: "/violation/red-light/" },
  { label: "DUI Under 21", href: "/violation/dui-under-21/" },
  { label: "Fight Traffic Ticket California", href: "/help/fight-traffic-ticket-ca/" },
  { label: "Contest Speeding Ticket CA", href: "/help/contest-speeding-ticket-ca/" },
  { label: "Traffic Ticket Dismissal California", href: "/help/traffic-ticket-dismissal-ca/" },
  { label: "Trial by Written Declaration California", href: "/guides/trial-by-written-declaration-california/" },
];

const legalLinks: FooterLink[] = [
  { label: "Terms of Service", href: "/terms/" },
  { label: "Privacy Policy", href: "/privacy/" },
  { label: "Cookie Policy", href: "/cookie-policy/" },
  { label: "Refund Policy", href: "/refund/" },
  { label: "Disclaimer", href: "/disclaimer/" },
];

function LinkGroup({ links }: { links: FooterLink[] }) {
  return (
    <ul className="mt-3 space-y-2">
      {links.map((item) => (
        <li key={`${item.label}-${item.href}`}>
          <a className="text-sm text-muted-foreground transition-colors hover:text-primary" href={item.href}>
            {item.label}
          </a>
        </li>
      ))}
    </ul>
  );
}

export default function Footer() {
  return (
    <footer className="border-t border-border bg-slate-50">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <section className="grid grid-cols-1 gap-8 lg:grid-cols-6">
          <div className="lg:pr-6">
            <p className="text-sm leading-7 text-muted-foreground">
              California traffic-ticket review and preparation tools built around your actual citation.
            </p>
          </div>
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:col-span-5 lg:grid-cols-5">
            <div>
              <h3 className="text-xs font-semibold uppercase tracking-[0.12em] text-foreground">Product</h3>
              <LinkGroup links={productLinks} />
            </div>
            <div>
              <h3 className="text-xs font-semibold uppercase tracking-[0.12em] text-foreground">Account</h3>
              <LinkGroup links={accountLinks} />
            </div>
            <div>
              <h3 className="text-xs font-semibold uppercase tracking-[0.12em] text-foreground">Support</h3>
              <LinkGroup links={supportLinks} />
            </div>
            <div>
              <h3 className="text-xs font-semibold uppercase tracking-[0.12em] text-foreground">Tools & Guides</h3>
              <LinkGroup links={toolsLinks} />
            </div>
            <div>
              <h3 className="text-xs font-semibold uppercase tracking-[0.12em] text-foreground">Legal</h3>
              <LinkGroup links={legalLinks} />
              <div className="mt-2">
                <CookieSettingsButton />
              </div>
            </div>
          </div>
        </section>

        <section className="mt-10 border-t border-border pt-8">
          <h3 className="text-xs font-semibold uppercase tracking-[0.12em] text-foreground">California Traffic Help</h3>
          <ul className="mt-4 grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-3">
            {seoLinks.map((item) => (
              <li key={`${item.label}-${item.href}`}>
                <a className="text-sm text-muted-foreground transition-colors hover:text-primary" href={item.href}>
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </section>

        <section className="mt-10 border-t border-border pt-6">
          <p className="text-xs leading-6 text-muted-foreground">
            JusticeDrive is not a law firm and does not provide legal advice. We provide software tools for document
            preparation and case organization. No guarantee of outcome. Results depend on court review and submitted
            evidence.
          </p>
        </section>

        <div className="mt-8 border-t border-border pt-6 text-center text-sm text-gray-500">
          © 2026 JusticeDrive CA - Not legal advice
          <br />
          Expertly serving the Superior Court of California and beyond
        </div>
      </div>
    </footer>
  );
}
